var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "id_card"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "id_card_2",
    d: "M14.077 12.7308H18.6152V11.2308H14.077V12.7308ZM14.077 9.84625H18.6152V8.34625H14.077V9.84625ZM5.38475 15.6538H12.6923V15.2963C12.6923 14.6296 12.3624 14.1058 11.7027 13.725C11.0432 13.3442 10.1552 13.1538 9.0385 13.1538C7.92183 13.1538 7.03367 13.3442 6.374 13.725C5.7145 14.1058 5.38475 14.6296 5.38475 15.2963V15.6538ZM9.0385 11.8463C9.52433 11.8463 9.93742 11.676 10.2777 11.3355C10.6182 10.9952 10.7885 10.5821 10.7885 10.0962C10.7885 9.61025 10.6182 9.19708 10.2777 8.85675C9.93742 8.51642 9.52433 8.34625 9.0385 8.34625C8.55267 8.34625 8.1395 8.51642 7.799 8.85675C7.45867 9.19708 7.2885 9.61025 7.2885 10.0962C7.2885 10.5821 7.45867 10.9952 7.799 11.3355C8.1395 11.676 8.55267 11.8463 9.0385 11.8463ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775ZM4.30775 18H19.6923C19.7693 18 19.8398 17.9679 19.9038 17.9038C19.9679 17.8398 20 17.7693 20 17.6923V6.30775C20 6.23075 19.9679 6.16025 19.9038 6.09625C19.8398 6.03208 19.7693 6 19.6923 6H4.30775C4.23075 6 4.16025 6.03208 4.09625 6.09625C4.03208 6.16025 4 6.23075 4 6.30775V17.6923C4 17.7693 4.03208 17.8398 4.09625 17.9038C4.16025 17.9679 4.23075 18 4.30775 18Z",
    fill: "url(#paint0_linear_0_129)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_129",
    x1: 2.38456,
    y1: 5.15331,
    x2: 23.4756,
    y2: 14.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id_card.e208ccd64aabb77bd0942512d83d76dc.svg";
export { ForwardRef as ReactComponent };